


























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import ProvinceLabel from "@/modules/regions/ProvinceLabel/index.vue";
import {toSlug} from "@/shared/services/helper/utils";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {ProvinceStore} from "@/modules/regionsv2/province/store";

@Component({
    name: "ProvinceSelectorV2",
    components: {ProvinceLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: String, default: "Chọn tỉnh/tp"}) readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';


    @Prop({default: 1})
    readonly countryId!: number;

    @Model("change", {type: Number})
    readonly provinceId!: number;

    @Emit('change')
    handleChange(value?: number) {

        this.$emit("province-name", ProvinceStore.data[value as any]?.name || "");
        return value;
    }

    get provinceIds() {
        return ProvinceStore.mapIdsByCountryId[this.countryId];
    }

    get provinceData() {
        return ProvinceStore.data;
    }

    @Watch("countryId", {immediate: true})
    async onChangeCountryId(val: number, oldVal: number) {
        if (!val) {
            this.handleChange();
        }
        try {
            await ProvinceStore.listProvincesByCountryV21(val);
            if (!this.provinceId) return;
            if (this.provinceIds) {
                if (this.provinceIds.some((id: number) => id === this.provinceId))
                    return;
                this.handleChange();
            }
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: e?.response?.data?.message || "Đã có lỗi xảy ra"
            });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ")
                .toLowerCase()) >= 0);
    }

    onBlur() {
        this.$parent.$emit('blur');
    }
}
